// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FuvK","field":"styles_field__SqKqR","fieldCol":"styles_fieldCol__3FfyR","diffCol":"styles_diffCol__29CcD","diff":"styles_diff__EKXIc"};